module.exports = "<div style=\"display: inline-flex;\">\n  <nav aria-label=\"breadcrumb\">\n    <ol class=\"breadcrumb\">\n      <li class=\"breadcrumb-item active\" aria-current=\"page\">Home</li>\n    </ol>\n  </nav>\n</div>\n<div class=\"example-sidenav-content\">\n  <mat-card><h1>Seja bem vindo(a) ao Sign. </h1> </mat-card>\n  <a mat-button href=\"\" routerLink=\"/documentlist\">Documents</a>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/assinatura-eletronica/assinatura-eletronica.component.html
// module id = ../../../../../src/app/components/assinatura-eletronica/assinatura-eletronica.component.html
// module chunks = main